import {
  CoverageType,
  DigitalCoverages,
} from '@sky-distribution/gp-onboarding-generic-submission';
import { CoverageCodes } from '@sky-distribution/gp-onboarding-policy-service';
import { GroupCodes } from './coverages.type';

export const digitalCoverages: DigitalCoverages = {
  [GroupCodes.GroupShortCircuit]: {
    displayOrder: 4,
    fake: true,
    type: CoverageType.group,
    name: 'Przepięcie',
    description: 'uszkodzenia wywołane przez skok napięcia',
    hideTermValue: true,
    codeIdentifier: GroupCodes.GroupShortCircuit,
    triggeredBy: [
      CoverageCodes.EquipmentShortCircuit,
      CoverageCodes.FixedElementsShortCircuit,
    ],
    coverage: {
      selected: true,
      codeIdentifier: GroupCodes.GroupShortCircuit,
    },
  },
  [GroupCodes.GroupFlood]: {
    displayOrder: 3,
    fake: true,
    type: CoverageType.group,
    name: 'Powódź',
    description: '',
    hideTermValue: true,
    codeIdentifier: GroupCodes.GroupFlood,
    triggeredBy: [
      CoverageCodes.EquipmentFlood,
      CoverageCodes.FixedElementsFlood,
    ],
    coverage: {
      selected: true,
      codeIdentifier: GroupCodes.GroupFlood,
    },
  },
  [GroupCodes.GroupBurglary]: {
    displayOrder: 5,
    fake: true,
    type: CoverageType.group,
    name: 'Kradzież z włamaniem',
    description: 'wyposażenie i elementy stałe',
    codeIdentifier: GroupCodes.GroupBurglary,
    triggeredBy: [
      CoverageCodes.EquipmentBurglary,
      CoverageCodes.FixedElementsBurglary,
    ],
    visibilityTriggerBy: [CoverageCodes.Equipment],
    coverage: {
      selected: true,
      codeIdentifier: GroupCodes.GroupBurglary,
    },
  },
  [GroupCodes.FloodingFixedElements]: {
    fake: true,
    isHidden: true,
    type: CoverageType.group,
    name: 'Zalanie',
    icon: 'flooding',
    codeIdentifier: GroupCodes.FloodingFixedElements,
    triggeredBy: [CoverageCodes.FixedElements],
    coverage: {
      selected: true,
      codeIdentifier: GroupCodes.FloodingFixedElements,
    },
  },
  [GroupCodes.FloodingEquipment]: {
    fake: true,
    isHidden: true,
    type: CoverageType.group,
    name: 'Zalanie',
    icon: 'flooding',
    codeIdentifier: GroupCodes.FloodingEquipment,
    triggeredBy: [CoverageCodes.Equipment],
    coverage: {
      selected: true,
      codeIdentifier: GroupCodes.FloodingEquipment,
    },
  },
  [GroupCodes.VandalismEquipment]: {
    fake: true,
    isHidden: true,
    type: CoverageType.group,
    name: 'Wandalizm',
    icon: 'vandalism',
    codeIdentifier: GroupCodes.VandalismEquipment,
    triggeredBy: [CoverageCodes.Equipment],
    coverage: {
      selected: true,
      codeIdentifier: GroupCodes.VandalismEquipment,
    },
  },
  [GroupCodes.VandalismFixedElements]: {
    fake: true,
    isHidden: true,
    type: CoverageType.group,
    name: 'Wandalizm',
    icon: 'vandalism',
    codeIdentifier: GroupCodes.VandalismFixedElements,
    triggeredBy: [CoverageCodes.FixedElements],
    coverage: {
      selected: true,
      codeIdentifier: GroupCodes.VandalismFixedElements,
    },
  },
  [GroupCodes.FireFixedElements]: {
    fake: true,
    isHidden: true,
    type: CoverageType.group,
    name: 'Pożar',
    icon: 'fire',
    codeIdentifier: GroupCodes.FireFixedElements,
    triggeredBy: [CoverageCodes.FixedElements],
    coverage: {
      selected: true,
      codeIdentifier: GroupCodes.FireFixedElements,
    },
  },
  [GroupCodes.FireEquipment]: {
    fake: true,
    isHidden: true,
    type: CoverageType.group,
    name: 'Pożar',
    icon: 'fire',
    codeIdentifier: GroupCodes.FireEquipment,
    triggeredBy: [CoverageCodes.Equipment],
    coverage: {
      selected: true,
      codeIdentifier: GroupCodes.FireEquipment,
    },
  },
};
